import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'

import router from './router'
import store from './store'

import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import JsonViewer from 'vue-json-viewer'

import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer"

import {manifestServer, weighingServer, dataServer} from './api/config'

Vue.config.productionTip = false

Vue.prototype.$weight = weighingServer
Vue.prototype.$manifest = manifestServer
Vue.prototype.$server = dataServer

Vue.use(JsonViewer)
Vue.use(Viewer)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
